module.exports = __webpack_public_path__ + "img/ruai.ce0a77eb.png";